import { create } from 'zustand';
import type { LobbyView, PlayerView } from '@mafia/core';

export type Tone = 'info' | 'good' | 'bad';
export interface Toast {
  id: number;
  text: string;
  tone: Tone;
}

interface GameStore {
  connection: 'idle' | 'connecting' | 'online' | 'offline';
  lobby: LobbyView | null;
  /** Последний персональный снапшот игры (или финальный, пока игрок не вернулся в лобби). */
  view: PlayerView | null;
  /** Комната, к которой относится view (итоги игры показываются только в ней). */
  viewRoomId: string | null;
  /** Поправка часов: serverNow - Date.now(). */
  offset: number;
  toasts: Toast[];
  toast(text: string, tone?: Tone): void;
  dismiss(id: number): void;
  /** Закрыть экран итогов и вернуться в лобби. */
  closeGame(): void;
  reset(): void;
}

let toastId = 0;

export const useGame = create<GameStore>((set, get) => ({
  connection: 'idle',
  lobby: null,
  view: null,
  viewRoomId: null,
  offset: 0,
  toasts: [],

  toast(text, tone = 'info') {
    const id = ++toastId;
    set({ toasts: [...get().toasts.slice(-3), { id, text, tone }] });
    setTimeout(() => get().dismiss(id), 5000);
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
  closeGame() {
    set({ view: null });
  },
  reset() {
    set({ connection: 'idle', lobby: null, view: null, viewRoomId: null, toasts: [] });
  },
}));

/** Текущее серверное время (мс) с поправкой часов клиента. */
export const serverNow = () => Date.now() + useGame.getState().offset;
